import { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import CardGrid from "../components/card/CardGrid";
import ChannelCard from "../components/card/ChannelCard";
import PlaceholderCard from "../components/card/PlaceholderCard";
import CategorySelect from "../components/CategorySelect";

import useInfiniteScroll from "../hooks/useInfiniteScroll";
import useInput from "../hooks/useInput";
import { useSearch } from "../hooks/useSearch";

import { AppContext } from "../App";
import { range } from "../lib/range";

import magnifier from "../assets/images/search-outline.svg";
import logo from "../assets/images/logo.png";

export default function Search() {
    const appContext = useContext(AppContext);

    const [searchParams, setSearchParams] = useSearchParams();
    const [query, queryProps] = useInput(searchParams.get("k") || "");
    const [searchResult, search, isLoading, loadMore] = useSearch(
        query,
        appContext?.category
    );
    const hasReachedEnd = useInfiniteScroll(300);

    useEffect(() => {
        if (searchResult && hasReachedEnd) loadMore();
    }, [hasReachedEnd]);

    function handleSearch() {
        if (query) {
            setSearchParams({ k: query });
            search(query, appContext?.category || "hetero");
        }
    }

    useEffect(() => {
        handleSearch();
    }, [appContext]);

    useEffect(() => {
        const timeout = setTimeout(handleSearch, 500);
        return () => clearTimeout(timeout);
    }, [query]);

    return (
        <div className="mt-4 flex w-11/12 flex-col items-center gap-6 md:mt-0 md:gap-6">
            <div className="flex flex-col gap-2 text-left md:gap-0 md:text-center">
                <p>
                    Seja bem vindo ao Buscador de Videos do{" "}
                    <b>Robozinho do XVIDEOS.</b>
                </p>
                <p>
                    Digite abaixo o <b>NOME DO CANAL/NOME DO(A) MODELO</b> ou{" "}
                    <b>ALGUM TERMO</b>.
                </p>
                <p>(Ex: Corno, trans, gay) que quer assistir.</p>
            </div>

            <div className="flex w-full max-w-3xl flex-col gap-4">
                {appContext && (
                    <div className="flex items-center gap-1 self-end rounded-md border border-xv-border-color bg-xv-bg-2 py-2 pl-4">
                        <span>Categoria: </span>
                        <CategorySelect
                            categoryType={appContext.category}
                            setCategoryType={appContext.setCategory}
                        />
                    </div>
                )}
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSearch();
                    }}
                    className="flex w-full px-[1px]"
                >
                    <input
                        className="w-full rounded-l-full border border-xv-border-color bg-xv-bg-2 px-5 py-3 outline-none focus:border-xv-red"
                        placeholder="Pesquisar XVideos"
                        type="search"
                        {...queryProps}
                    />
                    <button
                        className="rounded-r-full border border-xv-red bg-xv-red px-5 py-3 focus:outline-dotted focus:outline-1 hocus:brightness-90"
                        type="submit"
                    >
                        <img
                            className="h-6 w-6"
                            src={magnifier}
                            alt="Pesquisar"
                        />
                    </button>
                </form>
            </div>
            <CardGrid>
                {[
                    ...(searchResult
                        ? searchResult.channels.map((channel, i) => (
                              <ChannelCard
                                  key={i}
                                  {...channel}
                                  href={"/channel" + channel.href}
                              />
                          ))
                        : []),

                    ...(isLoading
                        ? range(0, 8).map((i) => (
                              <PlaceholderCard
                                  key={
                                      (searchResult
                                          ? searchResult.channels.length
                                          : 0) + i
                                  }
                              />
                          ))
                        : []),
                ]}
            </CardGrid>
        </div>
    );
}
